import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CAREER_BENEFITS = ['Seguridad para practicar', 'Método estructurado', 'Base profesional sólida', 'Herramientas para comenzar a ofrecer sesiones'];
export function CareerSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#f5ede0] py-20 md:py-28 px-4" data-id="element-92">
      <div className="container mx-auto max-w-4xl" data-id="element-93">
        <div ref={ref1} className={`reveal text-center mb-12 ${vis1 ? 'is-visible' : ''}`} data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6 leading-tight" data-id="element-95">
            Sí, puedes convertir esto en una salida laboral
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-96">
            El bienestar y las terapias alternativas están en crecimiento.
            <span className="block mt-2 font-semibold text-amber-700" data-id="element-97">
              Una sola sesión de Reiki puede tener un valor significativo en el
              mercado.
            </span>
          </p>
        </div>

        <div ref={ref2} className={`reveal bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-amber-100/50 ${vis2 ? 'is-visible' : ''}`} data-id="element-98">
          <h3 className="text-2xl font-serif font-bold text-gray-900 mb-8 text-center" data-id="element-99">
            Al terminar esta formación tendrás:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-100">
            {CAREER_BENEFITS.map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-101">
                <div className="bg-amber-100 p-2 rounded-full flex-shrink-0" data-id="element-102">
                  <CheckIcon className="w-5 h-5 text-amber-600" strokeWidth={3} data-id="element-103" />
                </div>
                <span className="text-gray-800 font-medium text-lg" data-id="element-104">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="text-center border-t border-gray-100 pt-8" data-id="element-105">
            <p className="text-xl md:text-2xl font-serif font-bold text-gray-900 mb-2" data-id="element-106">
              No compras información. Adquieres una habilidad.
            </p>
            <p className="text-lg text-amber-600 font-medium" data-id="element-107">
              Y las habilidades generan ingresos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}